import React, { useContext, useState } from 'react'
import 'react-quill/dist/quill.snow.css'

import { CardContent, CardFooter } from '@components/layout/Card'
import { Button } from '@components/Button'

import { NotesContext } from '../../context'
import NoteEditor from '../../components/NoteEditor'
import Toolbar from '../../components/Toolbar'
import '../../styles/Note.styles.sass'

const baseClass = "scenario-notes__create"

export const Form = () => {
  const {
    state: { note, loading },
    actions: { updateNote, back }
  } = useContext(NotesContext)
  const [newNote, setNewNote] = useState({...note})

  const onEditorChange = (value) => {
    setNewNote(state => ({...state, body: value}))
  }
  const onToggleVisibility = () => {
    setNewNote(state => ({ ...state, visibility: state.visibility == 0 ? 1 : 0 }))
  }
 
  const onUpdateNote = () => {
    updateNote(newNote)
  }
  
  return (
    <>
      <CardContent className={baseClass}>
        <Main note={newNote} onEditorChange={onEditorChange} onToggleNoteVisibility={onToggleVisibility} />
      </CardContent>
      <Actions loading={loading} onSave={onUpdateNote} onBack={back} />
    </>
  )
}

const Main = ({note, onToggleNoteVisibility, onEditorChange}) => {

  const isPrivateNote = note.visibility == 1

  return (
    <div className={`${baseClass}-main`}>
      <Toolbar isPrivateNote={isPrivateNote} onToggleNoteVisibility={onToggleNoteVisibility} />
      <NoteEditor
        value={note.body}
        onChange={onEditorChange}
        locked={note.noteTemplate?.isLocked}
      />
    </div>
  )
}

const Actions = ({ onSave, onBack, loading }) => {

  return (
    <CardFooter>
      <div className={`${baseClass}-actions`}>
        <Button fullWidth secondary onClick={onBack}>
          Cancel
        </Button>
        <Button
          fullWidth
          primary
          disabled={loading}
          trackAs='Update scenario note'
          onClick={onSave}
        >
          {loading ? 'Saving note...' : "Save" }
        </Button>
      </div>
    </CardFooter>
  )
}
